<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
    style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body qre-modal-body" [class.qre-modal-body--loading]="showFormLoader" [hidden]="minimise">
  @if (showFormLoader) {
    <div class="qre-initial-loader">
      <i class="fa fa-spinner fa-spin qre-initial-loader__icon"></i>
    </div>
  }

  @if (!showFormLoader) {
    <div>
      <ul class="nav nav-pills schedule-tabs" role="tablist">
        <li [class.active]="activeScheduleTab === 0">
          <a (click)="onScheduleTabChange(0)" style="cursor: pointer;" class="btn-sm">QRE - R&amp;D</a>
        </li>
        <li [class.active]="activeScheduleTab === 1">
          <a (click)="onScheduleTabChange(1)" style="cursor: pointer;" class="btn-sm">Audit</a>
        </li>
      </ul>
      @if (activeScheduleTab === 1) {
        <div class="audit-tab-placeholder">
          <p>Audit view is not available in this release.</p>
        </div>
      }
      @if (activeScheduleTab === 0) {
        <div>
          <div class="entityDetails">
            <table class="custom-table entity-info-table">
              <tbody>
                <tr>
                  <td class="LayerLine1" nowrap>Entity:</td>
                  <td class="LayerData1" nowrap>{{ entityDisplay }}</td>
                  <td class="LayerLine1" nowrap>Business:</td>
                  <td class="LayerData1" nowrap>{{ businessDisplay }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="qre-summary-label">QRE Summary</div>
          <div class="divShadow qre-summary-wrapper">
            <table class="gt-reclass-table table table-hover table-bordered table-striped table-condensed custom-table qre-summary-table">
              <thead>
                <tr>
                  <th>Total Type</th>
                  <th>{{ summaryCol2 }}</th>
                  <th>{{ summaryCol3 }}</th>
                  <th>{{ summaryCol4 }}</th>
                  <th>{{ summaryCol5 }}</th>
                  <th>Total Base Year QRE</th>
                </tr>
              </thead>
              @if (noRecords) {
                <tbody>
                  <tr>
                    <td colspan="6" class="loading-table"><b>No Data Available</b></td>
                  </tr>
                </tbody>
              }
              @if (!noRecords) {
                <tbody>
                  <tr>
                    <td>Total QRE (100%)</td>
                    <td class="text-right">{{ summary.CURRENT_YEAR_CQRE | number:'1.0-0' }}</td>
                    <td class="text-right">{{ summary.CURRENT_one_QRE | number:'1.0-0' }}</td>
                    <td class="text-right">{{ summary.CURRENT_two_QRE | number:'1.0-0' }}</td>
                    <td class="text-right">{{ summary.CURRENT_three_QRE | number:'1.0-0' }}</td>
                    <td class="text-right">{{ summary.CURRENT_TOTAL_QRE | number:'1.0-0' }}</td>
                  </tr>
                  <tr>
                    <td>Total Applicable QRE</td>
                    <td class="text-right">{{ summary.CURRENT_YEAR_CQRE_Y | number:'1.0-0' }}</td>
                    <td class="text-right">{{ summary.CURRENT_one_QRE_Y | number:'1.0-0' }}</td>
                    <td class="text-right">{{ summary.CURRENT_two_QRE_Y | number:'1.0-0' }}</td>
                    <td class="text-right">{{ summary.CURRENT_three_QRE_Y | number:'1.0-0' }}</td>
                    <td class="text-right">{{ summary.CURRENT_TOTAL_QRE_Y | number:'1.0-0' }}</td>
                  </tr>
                </tbody>
              }
            </table>
          </div>
          <div class="copy-section">
            <label>Copy QRE - R&amp;D Expenses From</label>
            @if (!hideCopy) {
              <select class="form-control input-sm copy-select"
                [(ngModel)]="copyValue" (ngModelChange)="onCopyValueChange($event)">
                @for (item of templateData; track item) {
                  <option [ngValue]="item">{{ item }}</option>
                }
              </select>
            }
            @if (hideCopy) {
              <input class="form-control input-sm" [ngModel]="copyValue" readonly>
            }
          </div>
          <ul class="nav nav-pills year-tabs" role="tablist">
            @for (tab of yearTabs; track tab; let i = $index) {
              <li [class.active]="selectedTab === i">
                <a (click)="onTabChange(i)" style="cursor: pointer;" class="btn-sm">{{ tab }}</a>
              </li>
            }
          </ul>
          <div class="divShadow tab-table-wrapper">
            <!-- Current Year -->
            @if (selectedTab === 0) {
              <table class="gt-reclass-table table table-hover table-bordered table-striped table-condensed custom-table qre-detail-table">
                <thead>
                  <tr>
                    <th class="action-col"></th>
                    <th>Form 6765 Line</th>
                    <th>Return As Filed R&amp;D Exp. (100%)</th>
                    <th>Applicable (%)</th>
                    <th>Return As Filed QRE (Applicable)</th>
                    <th>State</th>
                    <th>Business Component</th>
                    <th>BC Type</th>
                    <th>Software Type</th>
                  </tr>
                </thead>
                @if (noRecords && !tab1Rows.length) {
                  <tbody>
                    <tr><td colspan="9" class="loading-table"><b>No Data Available</b></td></tr>
                  </tbody>
                }
                @if (tab1Rows.length) {
                  <tbody>
                    @for (row of tab1Rows; track row; let i = $index) {
                      <tr>
                        <td class="action-col">
                          <i class="fa fa-minus-circle color-red row-action-icon" (click)="removeRow(i)"></i>
                        </td>
                        <td>
                          @if (!row.display_dropdown) {
                            <input class="form-control input-sm" [ngModel]="row.LINE_DESC_CY" readonly>
                          }
                          @if (row.display_dropdown) {
                            <select class="form-control input-sm"
                              [(ngModel)]="row.LINE_DESC_CY" (ngModelChange)="onLineChange(row, 'CY')">
                              <option [ngValue]="''">Select</option>
                              @for (lineDesc of lineDescriptionOptions; track lineDesc) {
                                <option [ngValue]="lineDesc">{{ lineDesc }}</option>
                              }
                            </select>
                          }
                        </td>
                        <td><input class="form-control input-sm text-right" type="number" [(ngModel)]="row.RAF_CY" (ngModelChange)="onReturnAsQRE(i, row)"></td>
                        <td><input class="form-control input-sm text-right" [ngModel]="row.APPLICABLE_PERCENT_CY" readonly></td>
                        <td><input class="form-control input-sm text-right" [ngModel]="row.ADJ_TOTAL_CY" readonly></td>
                        <td>
                          <select class="form-control input-sm" [(ngModel)]="row.STATE_CY" (ngModelChange)="onLineChange(row, 'CY')">
                            <option [ngValue]="''">Select</option>
                            @for (stateName of stateNames; track stateName) {
                              <option [ngValue]="stateName">{{ stateName }}</option>
                            }
                          </select>
                        </td>
                        <td><input class="form-control input-sm" [(ngModel)]="row.business_component" (ngModelChange)="syncTab1TextFields(row)"></td>
                        <td><input class="form-control input-sm" [(ngModel)]="row.bc_type" (ngModelChange)="syncTab1TextFields(row)"></td>
                        <td><input class="form-control input-sm" [(ngModel)]="row.software_type" (ngModelChange)="syncTab1TextFields(row)"></td>
                      </tr>
                    }
                  </tbody>
                }
              </table>
            }
            <!-- Base Year 1 -->
            @if (selectedTab === 1) {
              <table class="gt-reclass-table table table-hover table-bordered table-striped table-condensed custom-table qre-detail-table">
                <thead>
                  <tr>
                    <th class="action-col"></th>
                    <th>Form 6765 Line</th>
                    <th>Return As Filed</th>
                    <th>EXAM</th>
                    <th>Consistency</th>
                    <th>Acquisition</th>
                    <th>Disposition</th>
                    <th>Annualization</th>
                    <th>STATE</th>
                    <th>{{ totalHeaderTab }}</th>
                    <th>{{ totalApplicableHeaderTab }}</th>
                  </tr>
                </thead>
                @if (noRecords && !tab2Rows.length) {
                  <tbody>
                    <tr><td colspan="11" class="loading-table"><b>No Data Available</b></td></tr>
                  </tbody>
                }
                @if (tab2Rows.length) {
                  <tbody>
                    @for (row of tab2Rows; track row; let i = $index) {
                      <tr>
                        <td class="action-col"><i class="fa fa-minus-circle color-red row-action-icon" (click)="removeRow(i)"></i></td>
                        <td>
                          <div class="line-desc-cell">
                            @if (!row.display_dropdown_tab2) {
                              <input class="form-control input-sm" [ngModel]="row.LINE_DESC_BY1" readonly>
                            }
                            @if (row.display_dropdown_tab2) {
                              <select class="form-control input-sm"
                                [(ngModel)]="row.LINE_DESC_BY1" (ngModelChange)="onLineChange(row, 'BY1')">
                                <option [ngValue]="''">Select</option>
                                @for (lineDesc of lineDescriptionOptions; track lineDesc) {
                                  <option [ngValue]="lineDesc">{{ lineDesc }}</option>
                                }
                              </select>
                            }
                            <span class="expand-toggle" (click)="toggleRowDetails(row)">
                              <i class="fa" [ngClass]="row.open ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                            </span>
                          </div>
                        </td>
                        <td><input class="form-control input-sm text-right" [ngModel]="row.RAF_BY1" readonly></td>
                        <td><input class="form-control input-sm text-right" type="number" [(ngModel)]="row.ADJ_CY_EXAM_BY1" (ngModelChange)="onBaseYearChange(i, row, 'BY1')"></td>
                        <td><input class="form-control input-sm text-right" type="number" [(ngModel)]="row.ADJ_CY_CONSITENCY_BY1" (ngModelChange)="onBaseYearChange(i, row, 'BY1')"></td>
                        <td><input class="form-control input-sm text-right" type="number" [(ngModel)]="row.ADJ_CY_ACQUISITION_BY1" (ngModelChange)="onBaseYearChange(i, row, 'BY1')"></td>
                        <td><input class="form-control input-sm text-right" type="number" [(ngModel)]="row.ADJ_CY_DISPOSITION_BY1" (ngModelChange)="onBaseYearChange(i, row, 'BY1')"></td>
                        <td><input class="form-control input-sm text-right" type="number" [(ngModel)]="row.ADJ_CY_ANNUALIZATION_BY1" (ngModelChange)="onBaseYearChange(i, row, 'BY1')"></td>
                        <td>
                          <select class="form-control input-sm" [(ngModel)]="row.STATE_BY1" (ngModelChange)="onLineChange(row, 'BY1')">
                            <option [ngValue]="''">Select</option>
                            @for (stateName of stateNames; track stateName) {
                              <option [ngValue]="stateName">{{ stateName }}</option>
                            }
                          </select>
                        </td>
                        <td><input class="form-control input-sm text-right" [ngModel]="row.ADJ_TOTAL_BY1" readonly></td>
                        <td><input class="form-control input-sm text-right" [ngModel]="row.ADJ_TOTAL_APPLICABLE_BY1" readonly></td>
                      </tr>
                      @if (row.open) {
                        <tr class="adjustment-details-row">
                          <td></td>
                          <td colspan="2">Adjustment Details</td>
                          <td><input class="form-control input-sm text-right" [(ngModel)]="row.ADJ_CY_EXAM_D_BY1"></td>
                          <td><input class="form-control input-sm text-right" [(ngModel)]="row.ADJ_CY_CONSITENCY_D_BY1"></td>
                          <td><input class="form-control input-sm text-right" [(ngModel)]="row.ADJ_CY_ACQUISITION_D_BY1"></td>
                          <td><input class="form-control input-sm text-right" [(ngModel)]="row.ADJ_CY_DISPOSITION_D_BY1"></td>
                          <td><input class="form-control input-sm text-right" [(ngModel)]="row.ADJ_CY_ANNUALIZATION_D_BY1"></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      }
                    }
                  </tbody>
                }
              </table>
            }
            <!-- Base Year 2 -->
            @if (selectedTab === 2) {
              <table class="gt-reclass-table table table-hover table-bordered table-striped table-condensed custom-table qre-detail-table">
                <thead>
                  <tr>
                    <th class="action-col"></th>
                    <th>Form 6765 Line</th>
                    <th>Return As Filed</th>
                    <th>{{ tab3Title }}</th>
                    <th>EXAM</th>
                    <th>Consistency</th>
                    <th>Acquisition</th>
                    <th>Disposition</th>
                    <th>Annualization</th>
                    <th>STATE</th>
                    <th>{{ totalHeaderTab }}</th>
                    <th>{{ totalApplicableHeaderTab }}</th>
                  </tr>
                </thead>
                @if (noRecords && !tab3Rows.length) {
                  <tbody>
                    <tr><td colspan="12" class="loading-table"><b>No Data Available</b></td></tr>
                  </tbody>
                }
                @if (tab3Rows.length) {
                  <tbody>
                    @for (row of tab3Rows; track row; let i = $index) {
                      <tr>
                        <td class="action-col"><i class="fa fa-minus-circle color-red row-action-icon" (click)="removeRow(i)"></i></td>
                        <td>
                          <div class="line-desc-cell">
                            @if (!row.display_dropdown_tab3) {
                              <input class="form-control input-sm" [ngModel]="row.LINE_DESC_BY2" readonly>
                            }
                            @if (row.display_dropdown_tab3) {
                              <select class="form-control input-sm"
                                [(ngModel)]="row.LINE_DESC_BY2" (ngModelChange)="onLineChange(row, 'BY2')">
                                <option [ngValue]="''">Select</option>
                                @for (lineDesc of lineDescriptionOptions; track lineDesc) {
                                  <option [ngValue]="lineDesc">{{ lineDesc }}</option>
                                }
                              </select>
                            }
                            <span class="expand-toggle" (click)="toggleRowDetails(row)">
                              <i class="fa" [ngClass]="row.open ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                            </span>
                          </div>
                        </td>
                        <td><input class="form-control input-sm text-right" [ngModel]="row.RAF_BY2" readonly></td>
                        <td><input class="form-control input-sm text-right" [ngModel]="row.ADJ_CY_1_BY2" readonly></td>
                        <td><input class="form-control input-sm text-right" type="number" [(ngModel)]="row.ADJ_CY_EXAM_BY2" (ngModelChange)="onBaseYearChange(i, row, 'BY2')"></td>
                        <td><input class="form-control input-sm text-right" type="number" [(ngModel)]="row.ADJ_CY_CONSITENCY_BY2" (ngModelChange)="onBaseYearChange(i, row, 'BY2')"></td>
                        <td><input class="form-control input-sm text-right" type="number" [(ngModel)]="row.ADJ_CY_ACQUISITION_BY2" (ngModelChange)="onBaseYearChange(i, row, 'BY2')"></td>
                        <td><input class="form-control input-sm text-right" type="number" [(ngModel)]="row.ADJ_CY_DISPOSITION_BY2" (ngModelChange)="onBaseYearChange(i, row, 'BY2')"></td>
                        <td><input class="form-control input-sm text-right" type="number" [(ngModel)]="row.ADJ_CY_ANNUALIZATION_BY2" (ngModelChange)="onBaseYearChange(i, row, 'BY2')"></td>
                        <td>
                          <select class="form-control input-sm" [(ngModel)]="row.STATE_BY2" (ngModelChange)="onLineChange(row, 'BY2')">
                            <option [ngValue]="''">Select</option>
                            @for (stateName of stateNames; track stateName) {
                              <option [ngValue]="stateName">{{ stateName }}</option>
                            }
                          </select>
                        </td>
                        <td><input class="form-control input-sm text-right" [ngModel]="row.ADJ_TOTAL_BY2" readonly></td>
                        <td><input class="form-control input-sm text-right" [ngModel]="row.ADJ_TOTAL_APPLICABLE_BY2" readonly></td>
                      </tr>
                      @if (row.open) {
                        <tr class="adjustment-details-row">
                          <td></td>
                          <td colspan="3">Adjustment Details</td>
                          <td><input class="form-control input-sm text-right" [(ngModel)]="row.ADJ_CY_EXAM_D_BY2"></td>
                          <td><input class="form-control input-sm text-right" [(ngModel)]="row.ADJ_CY_CONSITENCY_D_BY2"></td>
                          <td><input class="form-control input-sm text-right" [(ngModel)]="row.ADJ_CY_ACQUISITION_D_BY2"></td>
                          <td><input class="form-control input-sm text-right" [(ngModel)]="row.ADJ_CY_DISPOSITION_D_BY2"></td>
                          <td><input class="form-control input-sm text-right" [(ngModel)]="row.ADJ_CY_ANNUALIZATION_D_BY2"></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      }
                    }
                  </tbody>
                }
              </table>
            }
            <!-- Base Year 3 -->
            @if (selectedTab === 3) {
              <table class="gt-reclass-table table table-hover table-bordered table-striped table-condensed custom-table qre-detail-table">
                <thead>
                  <tr>
                    <th class="action-col"></th>
                    <th>Form 6765 Line</th>
                    <th>Return As Filed</th>
                    <th>{{ tab4Title1 }}</th>
                    <th>{{ tab4Title2 }}</th>
                    <th>EXAM</th>
                    <th>Consistency</th>
                    <th>Acquisition</th>
                    <th>Disposition</th>
                    <th>Annualization</th>
                    <th>STATE</th>
                    <th>{{ totalHeaderTab }}</th>
                    <th>{{ totalApplicableHeaderTab }}</th>
                  </tr>
                </thead>
                @if (noRecords && !tab4Rows.length) {
                  <tbody>
                    <tr><td colspan="13" class="loading-table"><b>No Data Available</b></td></tr>
                  </tbody>
                }
                @if (tab4Rows.length) {
                  <tbody>
                    @for (row of tab4Rows; track row; let i = $index) {
                      <tr>
                        <td class="action-col"><i class="fa fa-minus-circle color-red row-action-icon" (click)="removeRow(i)"></i></td>
                        <td>
                          <div class="line-desc-cell">
                            @if (!row.display_dropdown_tab4) {
                              <input class="form-control input-sm" [ngModel]="row.LINE_DESC_BY3" readonly>
                            }
                            @if (row.display_dropdown_tab4) {
                              <select class="form-control input-sm"
                                [(ngModel)]="row.LINE_DESC_BY3" (ngModelChange)="onLineChange(row, 'BY3')">
                                <option [ngValue]="''">Select</option>
                                @for (lineDesc of lineDescriptionOptions; track lineDesc) {
                                  <option [ngValue]="lineDesc">{{ lineDesc }}</option>
                                }
                              </select>
                            }
                            <span class="expand-toggle" (click)="toggleRowDetails(row)">
                              <i class="fa" [ngClass]="row.open ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                            </span>
                          </div>
                        </td>
                        <td><input class="form-control input-sm text-right" [ngModel]="row.RAF_BY3" readonly></td>
                        <td><input class="form-control input-sm text-right" [ngModel]="row.ADJ_CY_2_BY3" readonly></td>
                        <td><input class="form-control input-sm text-right" [ngModel]="row.ADJ_CY_1_BY3" readonly></td>
                        <td><input class="form-control input-sm text-right" type="number" [(ngModel)]="row.ADJ_CY_EXAM_BY3" (ngModelChange)="onBaseYearChange(i, row, 'BY3')"></td>
                        <td><input class="form-control input-sm text-right" type="number" [(ngModel)]="row.ADJ_CY_CONSITENCY_BY3" (ngModelChange)="onBaseYearChange(i, row, 'BY3')"></td>
                        <td><input class="form-control input-sm text-right" type="number" [(ngModel)]="row.ADJ_CY_ACQUISITION_BY3" (ngModelChange)="onBaseYearChange(i, row, 'BY3')"></td>
                        <td><input class="form-control input-sm text-right" type="number" [(ngModel)]="row.ADJ_CY_DISPOSITION_BY3" (ngModelChange)="onBaseYearChange(i, row, 'BY3')"></td>
                        <td><input class="form-control input-sm text-right" type="number" [(ngModel)]="row.ADJ_CY_ANNUALIZATION_BY3" (ngModelChange)="onBaseYearChange(i, row, 'BY3')"></td>
                        <td>
                          <select class="form-control input-sm" [(ngModel)]="row.STATE_BY3" (ngModelChange)="onLineChange(row, 'BY3')">
                            <option [ngValue]="''">Select</option>
                            @for (stateName of stateNames; track stateName) {
                              <option [ngValue]="stateName">{{ stateName }}</option>
                            }
                          </select>
                        </td>
                        <td><input class="form-control input-sm text-right" [ngModel]="row.ADJ_TOTAL_BY3" readonly></td>
                        <td><input class="form-control input-sm text-right" [ngModel]="row.ADJ_TOTAL_APPLICABLE_BY3" readonly></td>
                      </tr>
                      @if (row.open) {
                        <tr class="adjustment-details-row">
                          <td></td>
                          <td colspan="4">Adjustment Details</td>
                          <td><input class="form-control input-sm text-right" [(ngModel)]="row.ADJ_CY_EXAM_D_BY3"></td>
                          <td><input class="form-control input-sm text-right" [(ngModel)]="row.ADJ_CY_CONSITENCY_D_BY3"></td>
                          <td><input class="form-control input-sm text-right" [(ngModel)]="row.ADJ_CY_ACQUISITION_D_BY3"></td>
                          <td><input class="form-control input-sm text-right" [(ngModel)]="row.ADJ_CY_DISPOSITION_D_BY3"></td>
                          <td><input class="form-control input-sm text-right" [(ngModel)]="row.ADJ_CY_ANNUALIZATION_D_BY3"></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      }
                    }
                  </tbody>
                }
              </table>
            }
            <div class="add-row-action">
              <i class="fa fa-plus-circle color-green row-action-icon" (click)="addRow()"></i>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="crudLoading || isSaveClicked" (click)="save()">
    @if (crudLoading) {
      <span><i class="fa fa-spinner fa-pulse"></i></span>
      }Save
    </button>
    <button class="reset-button" type="button" (click)="reset()">Reset</button>
    <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
  </div>
